import { createContext, useContext, type ReactNode } from "react"
import { Card } from "@/components/ui/Card"

// True inside the product quick view, whose sections are white cards on its
// tinted body. Elsewhere (Push review's product panel) sections stay open
// blocks with a divider above.
export const SectionCards = createContext(false)

// One panel section: a heading with an optional note on the right, then its
// content. `header` replaces the heading row, for a section headed by its own
// controls.
export default function Section({ title, aside, header, children }: { title?: string; aside?: string; header?: ReactNode; children: ReactNode }) {
  const cards = useContext(SectionCards)
  const body = (
    <>
      {header ?? (
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="text-sm font-semibold text-foreground">{title}</h3>
          {aside && <span className="text-xs text-foreground">{aside}</span>}
        </div>
      )}
      {children}
    </>
  )
  if (cards) {
    return (
      <Card className="p-0">
        <section className="flex flex-col gap-2 px-3.5 py-3">{body}</section>
      </Card>
    )
  }
  return <section className="flex flex-col gap-2 border-t border-border px-5 py-4">{body}</section>
}
